// extracted by mini-css-extract-plugin
module.exports = {"PayoutMethod":"styles_PayoutMethod__KSmGd","PayoutMethod-content":"styles_PayoutMethod-content__1vTqD","PayoutMethod-list":"styles_PayoutMethod-list__1MSil"};